import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import PageContainer from "@/components/layouts/PageContainer";
import { Heading } from "@/components/heading";
import { Text } from "@/components/text";
import { Button } from "@/components/button";
import { ArrowLeftIcon } from "@heroicons/react/20/solid";
import { useCreateExamPaper } from "@/apis/exam_papers/createExamPaper";
import type { ICreateExamPaperRequest } from "@/apis/exam_papers/types";
import { ExamPaperForm } from "./components/ExamPaperForm";

const ExamPaperCreatePage: React.FC = () => {
  const navigate = useNavigate();
  const {
    mutate: createExamPaper,
    isPending,
    isError,
    error,
  } = useCreateExamPaper();
  const [serverError, setServerError] = useState<string | undefined>();

  // Form submission handler
  const handleSubmit = (formData: ICreateExamPaperRequest) => {
    // Call API
    createExamPaper(formData, {
      onSuccess: () => {
        // On success, navigate to the exam paper list
        navigate("/exam_papers");
      },
      onError: (error: any) => {
        // Handle server errors
        setServerError(error?.message || "Failed to create exam paper");
      },
    });
  };

  // Cancel handler
  const handleCancel = () => {
    navigate("/exam_papers");
  };

  return (
    <PageContainer>
      <div className="space-y-6">
        <div className="flex items-center gap-4">
          <Button plain onClick={handleCancel}>
            <ArrowLeftIcon className="h-5 w-5" />
            Back
          </Button>

          <div>
            <Heading>Create New Exam Paper</Heading>
            <Text className="text-zinc-500">
              Fill in the information below to create a new exam paper.
            </Text>
          </div>
        </div>

        {/* Exam paper creation form */}
        <div className="p-8 border border-gray-200 rounded-md bg-white">
          <ExamPaperForm
            onSubmit={handleSubmit}
            onCancel={handleCancel}
            isLoading={isPending}
            serverError={serverError}
            submitButtonText="Create Exam Paper"
          />
        </div>
      </div>
    </PageContainer>
  );
};

export default ExamPaperCreatePage;
